export default __webpack_public_path__ + "static/media/callForSubmissions_22.dafe9c44.pdf";